import Vue from 'vue';
import VueRouter from 'vue-router';

import DashboardComponent from '72cms-ui/components/DashboardComponent';
import MainPanelComponent from '72cms-ui/components/MainPanelComponent';
import PageEditorComponent from '72cms-ui/components/PageEditorComponent';
import config from './config/base';

Vue.use(VueRouter);

const routes = [
    {
        name: 'root',
        path: "/",
        redirect: config.routes.default,
    },
    {
        name: 'undefined',
        path: "/undefined",
        redirect: config.routes.default,
    },
    {
        name: 'dashboard',
        path: '/dashboard',
        component: DashboardComponent,
    },
    {
        name: 'generic',
        path: "/:endpoint/:id?/:relationship?/:relationshipId?",
        component: MainPanelComponent,
    },
];

export default new VueRouter({
    routes,
});



// WEBPACK FOOTER //
// ./resources/assets/cms/js/router.js